import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ServicesMenuInfinitySmallIcon extends BaseIcon {
  getChildren = () => [
    <path
        d="M4.5 4.5c2.7-.9 5.4.6 5.4 3 0 2.3-.9 3-3.3 4.9.5.1.9.1 1.4.1 3.3-.1 6.4-1.9 8-4.8C14.4 4.8 11.3 3 8 3c-3.3-.1-6.4 1.7-8 4.7 1.3-1.4 2.8-2.4 4.5-3.2z"
        fill="#cc1e46"/>,
    <path fill="#a51339"
          d="M5.3 3.3c-1.4.5-2.7 1.3-3.8 2.3C.9 6.2.4 6.9 0 7.7c1.3-1.3 2.8-2.4 4.5-3.1 1-.3 2.1-.3 3.1 0 .4-.4 1-.9 1.7-1.4-.5-.1-1-.2-1.4-.2-.9 0-1.7.1-2.6.3zM10.5 12.2c1.4-.4 2.7-1.2 3.8-2.3.6-.6 1.1-1.3 1.5-2-1.3 1.3-2.8 2.3-4.5 3.1-1 .3-2.1.3-3.1 0-.5.5-1.1.9-1.7 1.4.4.1.9.1 1.3.1 1 0 1.9-.1 2.7-.3z"/>,
    <path
        d="M6 11.7c.5-.4 1-.8 1.3-1.1C6.4 10 5.9 9.1 5.9 8c-.1-1 .2-1.9.8-2.7-.2 0-.4-.1-.6-.1-.4 0-.9.1-1.3.2-1.6.8-2.9 1.8-4.1 3l-.5.4c1.2 1.7 3 2.9 5 3.4l.8-.5z"
        fill="#e45785"/>
  ]
  getViewBox = () => '0 0 16 16'
}
